import React, { useLayoutEffect } from 'react';
import useSmoothScroll from "./useSmoothScroll";
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import Header from './components/Header.jsx';
import Footer from './components/Footer.jsx';
import Main from './pages/main/Main.jsx';
import Booking from './pages/booking/Booking.jsx';
import AdminDashboard from './pages/admin/AdminDashboard.jsx';
import AdminLogin from './pages/admin/AdminLogin.jsx';
import ProtectedRoute from './components/ProtectedRoute.jsx';
import OurCompany from './pages/our-company/OurCompany.jsx';
import PaymentSuccess from './pages/transaction/PaymentSuccess.jsx';
import PaymentFailed from './pages/transaction/PaymentFailed.jsx';
import PaymentCancelled from './pages/transaction/PaymentCancelled.jsx';
import PartnerWithUs from './pages/partner-with-us/PartnerWithUs.jsx';
import NewsRoom from './pages/news-room/NewsRoom.jsx';
import OurCommitment from './pages/our-commitment/OurCommitment.jsx';
import Properties from './pages/properties/Properties.jsx';
import PageTitle from './components/PageTitle.jsx'; 

function ScrollToTopHandler() {
  const { pathname } = useLocation();
  
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  useSmoothScroll();
  return (
    <div className="App">
      <Router>
        <PageTitle />
        <ScrollToTopHandler />
        <Routes>
          <Route path="/" element={
            <>
              <Header/>
              <Main />
              <Footer />
            </>
          } />
          <Route path="/booking" element={<Booking />} />
          <Route path="/booking/edit/:bookingId" element={<Booking editMode={true} />} />
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={
            <ProtectedRoute>
              <AdminDashboard />
            </ProtectedRoute>
          } />
  
            <Route path="/about-us" element={
              <>
                <Header/>
                <OurCompany />
                <Footer />
              </>
            } />
            
            <Route path="/properties" element={
              <>
                <Header/>
                <Properties />
                <Footer />
              </>
            } />
            
          <Route path="/api/beetzee/payment/success" element={<PaymentSuccess />} />
          <Route path="/api/beetzee/payment/failed" element={<PaymentFailed />} />
          <Route path="/api/beetzee/payment/cancelled" element={<PaymentCancelled />} />


            <Route path="/partner-with-us" element={
              <>
                <Header />
                <PartnerWithUs />
                <Footer />
              </>
            } />

            <Route path="/news-room" element={
            <>
              <Header />
              <NewsRoom />
              <Footer />
            </>
            } />

            <Route path="/our-commitment" element={
            <>
              <Header />
              <OurCommitment />
              <Footer />
            </>
            } />
            
       
        </Routes>
      </Router>
    </div>
  );
}

export default App;
